import { Injectable } from '@angular/core';
import { OtpService } from './otp.service';

@Injectable({
  providedIn: 'root'
})
export class OtpManagerService {

  constructor(private otpService: OtpService) { }

  initializeOtpWidget(): void {
    this.otpService.loadOtpWidget();
  }

  sendOtp(phoneNumber: string): void {
    this.otpService.sendOtp(phoneNumber);
  }

  async resendOtp(channel: string | null = null): Promise<any> {
    try {
      return await this.otpService.retryOtp(channel);
    } catch (error) {
      console.error('Error in OtpManagerService while resending OTP:', error);
      throw error;
    }
  }

  async verifyOtp(otp: string): Promise<any> {
    try {
      return await this.otpService.verifyOtp(otp);
    } catch (error) {
      console.error('Error in OtpManagerService while verifying OTP:', error);
      throw error;
    }
  }
}
